import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import IsEmpty from 'lodash';

import OrderItem from './OrderItem';
import { Flex, Button, Box, Text } from 'core/ui/atoms';
import { LIST_PAID_SIGNATURE_PROGRAM_ORDERS } from 'core/api/apollo/queries';
import { isLoading } from 'core/api/loadingHelpers';
import Loading from 'core/ui/components/Loading';
import { orderHistoryPath } from 'onramp/api/navigation';

const OrderHistory = () => {
  const history = useHistory();
  const { loading, error, data: { listPaidSignatureProgramOrders = {} } = {} } = useQuery(LIST_PAID_SIGNATURE_PROGRAM_ORDERS);

  if (isLoading(loading, listPaidSignatureProgramOrders, error)) {
    return <Loading />;
  }

  if (IsEmpty(listPaidSignatureProgramOrders)) {
    return null;
  }

  const naviagteToOrderHistory = () => {
    history.push(orderHistoryPath());
  };

  const RenderOrderHistory = () => {
    return listPaidSignatureProgramOrders.map((order) => (
      <OrderItem key={order.id} order={order} />
    ));
  };

  return (
    <Box>
      <Title>Order History</Title>
      <RenderOrderHistory />
      <Flex direction='row' justifyContent='center'>
        <ViewButton onClick={naviagteToOrderHistory}>VIEW ALL</ViewButton>
      </Flex>
    </Box>
  );
};

export default OrderHistory;

const ViewButton = styled(Button)`
  margin-top: 5px;
  margin-bottom: 15px;
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 5px;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
`;

const Title = styled(Text)`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
`;
